webpackJsonp([166168677012954],{

/***/ 981:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0028_firebat.jpg","type":"Unit","subtype":"Spellcaster","cost":2,"ATK":3,"HP":3,"rules_text_1":"①, ⤵ → Deal 2 damage to a patroller or building.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Firebat","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Red","spec":"Fire","bottom":"Tech I","rulings":[],"keywords":[],"slug":"firebat"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"firebat","keywords":[],"imageRegex":"/firebat.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-firebat-0cadcfb47fd836f19de7.js